// Build a walker's public fundraising URL using their short fundraiser_number
// (e.g. /f/1001). Falls back to the UUID-based path if the number is missing
// — both routes are wired in App.js and the backend accepts both.
export function fundraisePath(walker) {
  if (!walker) return '/f/';
  const num = walker.fundraiser_number;
  if (num) return `/f/${num}`;
  return `/fundraise/${walker.id || ''}`;
}

export function fundraiseUrl(walker, origin) {
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base}${fundraisePath(walker)}`;
}
